/** CoStar.Api.TeamSharing.Rights.Domain */
export var Domain;
(function (Domain) {
    Domain[Domain["None"] = 0] = "None";
    Domain[Domain["LeaseComps"] = 1] = "LeaseComps";
})(Domain || (Domain = {}));
/** CoStar.Api.TeamSharing.Rights.SharingPermissions */
export var SharingPermissions;
(function (SharingPermissions) {
    SharingPermissions[SharingPermissions["Inherited"] = 0] = "Inherited";
    SharingPermissions[SharingPermissions["Read"] = 1] = "Read";
    SharingPermissions[SharingPermissions["Edit"] = 2] = "Edit";
    SharingPermissions[SharingPermissions["ReadEdit"] = 3] = "ReadEdit";
    SharingPermissions[SharingPermissions["Delete"] = 4] = "Delete";
    SharingPermissions[SharingPermissions["ReadDelete"] = 5] = "ReadDelete";
    SharingPermissions[SharingPermissions["EditDelete"] = 6] = "EditDelete";
    SharingPermissions[SharingPermissions["ReadEditDelete"] = 7] = "ReadEditDelete";
})(SharingPermissions || (SharingPermissions = {}));
